module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"optionsActiveCampaignsLabel":"Displayed in plugin","optionsOtherCampaignsLabel":"Other campaigns"}}')
  delete Component.options._Ctor
}
